import { render, staticRenderFns } from "./strategy.vue?vue&type=template&id=4660d2fc&scoped=true"
import script from "./strategy.vue?vue&type=script&lang=js"
export * from "./strategy.vue?vue&type=script&lang=js"
import style0 from "./strategy.vue?vue&type=style&index=0&id=4660d2fc&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4660d2fc",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/app/erp_frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4660d2fc')) {
      api.createRecord('4660d2fc', component.options)
    } else {
      api.reload('4660d2fc', component.options)
    }
    module.hot.accept("./strategy.vue?vue&type=template&id=4660d2fc&scoped=true", function () {
      api.rerender('4660d2fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/center-setting/user/account/strategy.vue"
export default component.exports